module.exports = __webpack_public_path__ + "static/media/cards.8a0ac83b.jpg";